import Vue from 'vue';
import App from './App.vue';
import HotListWeeklyTiaraPlugin from './tiara-plugin.js';

Vue.use(HotListWeeklyTiaraPlugin);

window.initArticleWidget = (requestConfig, articleWidgetConfig) => {
	const { svcParam } = articleWidgetConfig;
	const el = svcParam === '' || svcParam === 'topRank' ? '.view_group' : '.view_card';
	
	new Vue({
		el,
		render: h => h(App, {
			props: {
				requestConfig,
				articleWidgetConfig
			}
		})
	});
};
